interface IPackageRegistrationContext {
  userId?: string;
  name?: string;
  email?: string;
}

const encodeUtf8Base64 = (value: unknown) => {
  const bytes = new TextEncoder().encode(JSON.stringify(value));
  let binary = "";
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return window.btoa(binary);
};

export const decodePackageRegistrationRef = (ref: string) => {
  const binary = window.atob(ref);
  const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
  return JSON.parse(new TextDecoder().decode(bytes));
};

export const buildPackageRegistrationUrl = (
  packageId: string,
  context: IPackageRegistrationContext = {}
) => {
  const url = new URL("/register", window.location.origin);
  url.searchParams.set(
    "ref",
    encodeUtf8Base64({
      ...context,
      packageId,
      redirect: false,
    })
  );
  return url.toString();
};
